export const eventIsMouseMove = (e) => e instanceof MouseEvent;
export const eventIsTouchMove = (e) => {
    // Touch events aren't supported by Safari, IE
    // and older versions of Edge, Firefox and Chrome as per
    // https://caniuse.com/mdn-api_touchevent
    // and will result in `reference error: cannot read variable TouchEvent`.
    if (!('TouchEvent' in window)) {
        return false;
    }
    return e instanceof TouchEvent;
};
